export const focusAmountError = 'Please enter an amount of $5 or more in $5 increments.';

export function focusQuantity(value) {
  const text = String(value).trim();
  if (!/^\d+$/.test(text)) return null;
  const amount = Number(text);
  return Number.isSafeInteger(amount) && amount >= 5 && amount % 5 === 0 ? amount / 5 : null;
}

export function validateFocusAmount(input) {
  if (!input || input.disabled) return true;
  const valid = focusQuantity(input.value) !== null;
  input.setAttribute('aria-invalid', String(!valid));
  const error = input.closest('.fm-focus-amount')?.querySelector('[data-fm-focus-error]');
  if (error) error.hidden = valid;
  if (!valid) input.focus();
  return valid;
}

if (typeof document !== 'undefined') {
  const enableForms = () => document.querySelectorAll('[data-fm-focus-submit]').forEach(button => { if (!button.closest('form')?.hasAttribute('aria-busy')) button.disabled = false; });
  enableForms();
  new MutationObserver(enableForms).observe(document.body, {childList: true, subtree: true});
  document.addEventListener('input', event => {
    if (!event.target.matches?.('[data-fm-focus-amount]')) return;
    event.target.removeAttribute('aria-invalid');
    const error = event.target.closest('.fm-focus-amount')?.querySelector('[data-fm-focus-error]');
    if (error) error.hidden = true;
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-fm-focus-form]');
    if (!form) return;
    event.preventDefault();
    if (form.hasAttribute('aria-busy')) return;
    const input = form.querySelector('[data-fm-focus-amount]');
    if (!validateFocusAmount(input)) return;
    const button = form.querySelector('[data-fm-focus-submit]');
    const error = form.querySelector('[data-fm-focus-cart-error]');
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    error.hidden = true;
    try {
      const response = await fetch(`${form.action}.js`, {method: 'POST',headers: {'Content-Type': 'application/json',Accept: 'application/json'},body: JSON.stringify({items: [{id: input.dataset.fmFocusVariant,quantity: focusQuantity(input.value)}]})});
      const result = await response.json();
      if (!response.ok || !result.items?.length) throw new Error('Cart add failed');
      window.location.assign(form.dataset.cartUrl);
    } catch {
      error.hidden = false;
      form.removeAttribute('aria-busy');
      button.disabled = false;
    }
  });
}
